<script>
export default {
  name: "DotBar",
};
</script>
<template>
  <div class="dotbar">
    <div class="dots">
      <img
        v-if="$store.state.currentLoc === 0"
        src="../assets/icons/cards.svg"
        alt="Cards icon"
        class="dot cities active"
      />
      <img v-else src="../assets/icons/cards-light.svg" alt="Cards icon" class="dot cities" />
      <div
        v-for="(loc, index) in $store.state.locations"
        :key="index"
        class="dot"
        :class="{active: $store.state.currentLoc === index + 1}"
      ></div>
    </div>
  </div>
</template>
<style lang="scss">
.dotbar {
  height: var(--bar-height);
  display: flex;
  justify-content: center;
  align-items: center;

  .dots {
    display: flex;
    justify-content: center;
    align-items: center;

    .dot {
      height: 6px;
      width: 6px;
      background-color: var(--light-color);
      margin: 0 4px;
      border-radius: 3px;

      transition: background-color 0.2s, width 0.2s;

      &.cities {
        height: 20px;
        width: 20px;
        background-color: transparent;

        &.active {
          width: 20px;
          background-color: transparent;
        }
      }

      &.active {
        width: 14px;
        background-color: var(--text-color);
      }
    }
  }
}
</style>
